import axios from "axios";

export const FETCH_PRICING_REQUEST = "FETCH_PRICING_REQUEST";
export const FETCH_PRICING_SUCCESS = "FETCH_PRICING_SUCCESS";
export const FETCH_PRICING_FAILURE = "FETCH_PRICING_FAILURE";

export const UPDATE_PRICING_REQUEST = "UPDATE_PRICING_REQUEST";
export const UPDATE_PRICING_SUCCESS = "UPDATE_PRICING_SUCCESS";

export const fetchPricingRequest = () => {
    return {
        type: FETCH_PRICING_REQUEST,
    };
};

export const fetchPricingSuccess = (reviews) => {
    return {
        type: FETCH_PRICING_SUCCESS,
        payload: reviews,
    };
};

export const fetchPricingFailure = (error) => {
    return {
        type: FETCH_PRICING_FAILURE,
        payload: error,
    };
};

export const updatePricingRequest = (shop, id) => {
    return {
        type: UPDATE_PRICING_REQUEST,
        payload: { shop: shop, id: id },
    };
};

export const updatePricingSuccess = (data) => {
    return {
        type: UPDATE_PRICING_SUCCESS,
        payload: data,
    };
};

export const fetchPricings = (params) => {
    return async (dispatch) => {
        dispatch(fetchPricingRequest());
        try {
            const response = await axios.get("/pricing", { params });

            dispatch(fetchPricingSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchPricingFailure(error.message));
        }
    };
};

// export const updatePlan = (id, shop) => {
//     return async (dispatch) => {
//         dispatch(fetchPricingRequest(shop, id));
//         try {
//             const element = document.getElementById("app");
//             const host = element.dataset.host;
//             let url = "/billing/" + id + "?shop=" + shop + "&host=" + host;

//             const response = await axios.get(url);
//             window.top.location.href = scrapeUrlsFromHtml(response.data);
//         } catch (error) {
//             console.log(error);
//             // dispatch(fetchPricingFailure(error.message));
//         }
//     };
// };

// export const switchToFree = (shop) => {
//     return async (dispatch) => {
//         dispatch(fetchPricingRequest(shop));
//         try {
//             await axios.get("/cancel-paid-plan?shop=" + shop);
//             dispatch(updatePricingSuccess([]));
//         } catch (error) {
//             console.log(error);
//             dispatch(fetchPricingFailure(error.message));
//         }
//     };
// };

// function scrapeUrlsFromHtml(html) {
//     // const parser = new DOMParser();
//     // console.log('html', html);
//     // const doc = parser.parseFromString(html, "text/html");
//     // console.log('doc', doc.textContent);
//     const redirectUrl = html.match(/const redirectUrl = "(.*?)";/)[1];
//     console.log("redirectUrl", redirectUrl);
//     return redirectUrl;
// }
